export default {
    fileUpload: {
        clickToUpload: "Clicca per caricare",
        andAttachFiles: "e allega file",
        orDragAndDrop: "oppure trascina e rilascia",
        defaultHint: "SVG, PNG, JPG o GIF (max. 800x400px)",
        complete: "Completato",
        uploading: "Caricamento in corso...",
        failed: "Fallito",
        delete: "Elimina",
        retry: "Riprova",
        tryAgain: "Riprova",
        uploadFailed: "Caricamento fallito, riprova",
        dragAndDrop: "o trascina e rilascia",
        maxFileSize: "Dimensione massima: {{size}}",
        acceptedFormats: "Formati accettati: {{formats}}",
        uploadSuccess: "File caricato con successo",
        uploadError: "Errore nel caricamento del file",
    },
    commandMenu: {
        title: "Menu Comandi",
        searchPlaceholder: "Cerca...",
        removeFilter: "Rimuovi filtro",
        noResults: "Nessun risultato trovato",
        startTyping: "Inizia a digitare per cercare...",
        entities: {
            container: "Container",
            sender: "Mittente",
            receiver: "Ricevente",
            account: "Account",
            address: "Rubrica",
            document: "Documenti",
        },
    },
    account: {
        viewProfile: "Visualizza profilo",
        documentation: "Documentazione",
        switchCompany: "Cambia azienda",
        signOut: "Esci",
    },
    aiChat: {
        title: "Summon Eve",
        placeholder: "Chiedi all'AI…",
        ariaLabel: "Chat AI",
        welcome: "Ciao, come posso aiutarti?",
        welcomeSubtitle: "Scegli un'azione per iniziare",
        initialMessage: "Ciao! Sono Eve. Come posso aiutarti a navigare le tue operazioni oggi?",
        actions: {
            createContainer: "Crea Container",
            createOrder: "Crea Ordine",
            createQuoteRequest: "Crea Richiesta Preventivo",
            createQuote: "Crea Preventivo",
            checkColdChain: "Verifica Catena del Freddo",
            financialRisks: "Rischi Finanziari",
            missingDocs: "Documenti Mancanti",
            containerUpdates: "Aggiornamenti Container",
            containerRiskAssessment: "Rischio container",
            copy: "Copia",
            copied: "Copiato negli appunti",
            copyFailed: "Copia fallita",
            regenerate: "Rigenera",
            edit: "Modifica",
            delete: "Elimina",
            deleteConfirm: "Sei sicuro di voler eliminare questo messaggio?",
            stop: "Ferma",
        },
        quickActionPrompts: {
            createContainer:
                "Devo creare un nuovo container con ID {{containerId}}. Aggiungilo al sistema se non esiste già, poi chiedimi se voglio aggiungere altri dettagli (porto di origine, porto di destinazione, ETA, ecc.).",
            containerRiskAssessment: "Mostrami i container con livello di rischio medio o alto che richiedono la mia attenzione.",
            missingDocs: "Elencami i container che hanno documenti mancanti o errori di validazione in modo che possa revisionarli manualmente.",
            containerUpdates: "Forniscimi un aggiornamento puntuale sullo stato dei container non ancora consegnati.",
        },
        createContainerModal: {
            title: "Crea container",
            containerIdPlaceholder: "ID container",
            submit: "Continua",
            cancel: "Annulla",
        },
        you: "Tu",
        assistant: "Eve Care",
        attach: "Allega",
        emoji: "Emoji",
        scrollToBottom: "Vai all'ultimo messaggio",
        toggleQuickActions: "Mostra/nascondi azioni rapide",
        reasoning: {
            thinking: "Pensando",
            thinkingInProgress: "Ragionamento in corso",
            toolCall: "Usando strumento",
            ragSearch: "Cercando nella conoscenza",
            delegating: "Delegando",
            responding: "Rispondendo",
            steps: "Passaggi di ragionamento",
            activity: "Attività Agente",
            activeAgents: "Agenti Attivi",
            toolCalls: "Chiamate a strumenti",
            delegations: "Deleghe tra agenti",
            waiting: "In attesa di informazioni...",
        },
        newChat: "Nuova chat",
        chatHistory: "Cronologia chat",
        noChats: "Nessuna chat ancora",
        untitledChat: "Chat senza titolo",
        messageCount: "{{count}} messaggi",
        closeTab: "Chiudi tab",
        deleteChat: "Elimina chat",
        confirmDelete: "Sei sicuro di voler eliminare questa chat?",
        renameChat: "Rinomina chat",
        chatTitle: "Titolo chat",
        saveTitle: "Salva titolo",
        editTitle: "Modifica titolo",
        select: "Seleziona",
        star: "Aggiungi ai preferiti",
        unstar: "Rimuovi dai preferiti",
        rename: "Rinomina",
        delete: "Elimina",
        selectAll: "Seleziona tutto",
        deselectAll: "Deseleziona tutto",
        selectedCount: "{{count}} selezionate",
        bulkDelete: "Elimina selezionate",
        confirmBulkDelete: "Eliminare {{count}} chat?",
        cancelEdit: "Annulla",
        wizard: {
            confirmed: "Perfetto! Continuiamo...",
            enterValue: "Inserisci il valore...",
            create: "Crea",
            cancelled: "Wizard annullato. Come posso aiutarti?",
            notSpecified: "Non specificato",
            container: {
                containerNumber: "Qual è il numero del container?",
                routeFrom: "Da quale città parte il container?",
                routeTo: "Verso quale città va il container?",
                eta: "Qual è la data di arrivo prevista (ETA)?",
                valueAmount: "Qual è il valore del container?",
                valueCurrency: "Quale valuta vuoi usare?",
                status: "Qual è lo stato del container?",
                receiverId: "Quale receiver vuoi selezionare?",
                shippingCompany: "Quale compagnia di shipping? (opzionale)",
                review: "Riepilogo:\n- Numero Container: {{containerNumber}}\n- Da: {{routeFrom}}\n- A: {{routeTo}}\n- ETA: {{eta}}\n- Valore: {{valueAmount}} {{valueCurrency}}\n- Stato: {{status}}\n- Receiver: {{receiver}}\n- Compagnia Shipping: {{shippingCompany}}",
                success: "Container creato con successo!",
                completed: "Container creato! Reindirizzamento...",
            },
            order: {
                shipperId: "Quale shipper vuoi selezionare?",
                targetDate: "Qual è la data target per l'ordine?",
                packingListRequested: "Quali dettagli vuoi nella packing list?",
                notes: "Note aggiuntive (opzionale):",
                review: "Riepilogo:\n- Shipper: {{shipper}}\n- Data Target: {{targetDate}}\n- Packing List: {{packingList}}\n- Note: {{notes}}",
                success: "Ordine creato con successo!",
                completed: "Ordine creato! Reindirizzamento...",
            },
            quoteRequest: {
                subject: "Qual è l'oggetto della richiesta di preventivo?",
                body: "Inserisci il testo della richiesta di preventivo:",
                recipients: "Seleziona i freight forwarder destinatari:",
                review: "Riepilogo:\n- Oggetto: {{subject}}\n- Corpo: {{body}}\n- Destinatari: {{recipients}}",
                success: "Richiesta di preventivo creata con successo!",
                completed: "Richiesta creata! Reindirizzamento...",
            },
            quoteResponse: {
                selectQuote: "A quale richiesta di preventivo vuoi rispondere?",
                usingContext: "Sto rispondendo alla richiesta: {{subject}}",
                responseSubject: "Qual è l'oggetto della risposta?",
                responseBody: "Inserisci il testo della risposta:",
                review: "Riepilogo:\n- Richiesta: {{quoteSubject}}\n- Oggetto Risposta: {{responseSubject}}\n- Corpo Risposta: {{responseBody}}",
                success: "Preventivo creato con successo!",
                completed: "Preventivo creato! Reindirizzamento...",
            },
        },
    },
    stats: {
        vsLastMonth: "vs mese scorso",
    },
    buttons: {
        submit: "Invia",
        cancel: "Annulla",
        save: "Salva",
        delete: "Elimina",
        edit: "Modifica",
        create: "Crea",
        update: "Aggiorna",
        add: "Aggiungi",
        remove: "Rimuovi",
        close: "Chiudi",
        back: "Indietro",
        next: "Avanti",
        previous: "Precedente",
        confirm: "Conferma",
        logout: "Esci",
        login: "Accedi",
        reset: "Reimposta",
        search: "Cerca",
        filter: "Filtra",
        clear: "Pulisci",
        apply: "Applica",
        upload: "Carica",
        download: "Scarica",
        view: "Visualizza",
        share: "Condividi",
        send: "Invia",
        invite: "Invita",
        accept: "Accetta",
        reject: "Rifiuta",
    },
    form: {
        required: "Campo obbligatorio",
        optional: "Opzionale",
        invalid: "Valore non valido",
        emailInvalid: "Indirizzo email non valido",
        passwordTooShort: "La password deve essere di almeno 8 caratteri",
        selectPlaceholder: "Seleziona un'opzione...",
        searchPlaceholder: "Cerca...",
        noResults: "Nessun risultato trovato",
        loading: "Caricamento...",
        errors: {
            allFieldsRequired: "Tutti i campi sono obbligatori",
            amountInvalid: "L'importo deve essere un numero maggiore di 0",
        },
    },
    validation: {
        required: "Questo campo è obbligatorio",
        email: "Inserisci un indirizzo email valido",
        minLength: "Deve essere di almeno {{count}} caratteri",
        maxLength: "Deve essere di massimo {{count}} caratteri",
        pattern: "Formato non valido",
    },
    errors: {
        generic: "Si è verificato un errore",
        network: "Errore di rete. Riprova.",
        unauthorized: "Accesso non autorizzato",
        notFound: "Risorsa non trovata",
        serverError: "Errore del server. Riprova più tardi.",
        unknown: "Errore sconosciuto",
    },
    messages: {
        success: "Operazione completata con successo",
        saved: "Salvato con successo",
        deleted: "Eliminato con successo",
        created: "Creato con successo",
        updated: "Aggiornato con successo",
        loading: "Caricamento...",
        noData: "Nessun dato disponibile",
        confirmDelete: "Sei sicuro di voler eliminare questo elemento?",
    },
    date: {
        today: "Oggi",
        yesterday: "Ieri",
        tomorrow: "Domani",
        thisWeek: "Questa settimana",
        thisMonth: "Questo mese",
        thisYear: "Quest'anno",
    },
    language: "Lingua",
    changeLanguage: "Cambia lingua",
    english: "English",
    italiano: "Italiano",
    pdfViewer: {
        prev: "Prec",
        next: "Succ",
        page: "Pagina",
        addRectangle: "Aggiungi Rettangolo",
        addRectangleHere: "Aggiungi rettangolo qui",
        loadingPdf: "Caricamento PDF...",
    },
    signOut: {
        confirm: {
            title: "Conferma disconnessione",
            message: "Sei sicuro di voler uscire? Dovrai effettuare nuovamente l'accesso per utilizzare l'applicazione.",
        },
    },
    accountSwitch: {
        switching: "Cambio account in corso...",
    },
    orderAccept: {
        confirmCreateQuotes: {
            title: "Crea richieste di preventivo",
            message: "Vuoi creare automaticamente le richieste di preventivo basate sulle specifiche di questo ordine?",
            createQuotes: "Sì, crea le richieste",
            acceptOnly: "No, accetta solo l'ordine",
        },
        creatingQuotes: "Creando le richieste di preventivo",
    },
    theme: "Tema",
    themeLight: "Chiaro",
    themeDark: "Scuro",
    themeSystem: "Sistema",
    modal: {
        close: "Chiudi",
        cancel: "Annulla",
        confirm: "Conferma",
        delete: "Elimina",
        ok: "OK",
    },
    askEve: {
        title: "Ask Eve",
    },
    controlHub: {
        title: "Control Hub",
    },
};
